module.exports = __webpack_public_path__ + "img/star3yellow.756eb05d.png";